document.querySelectorAll( '.b-interactive-map' ).forEach( ( block ) => {

	const map = block.querySelector( '.b-interactive-map__map' );
	const mapElements = map.querySelectorAll( '[id]' );
	const defaultColor = '#cbd3f0';
	const activeColor = '#4e5e98';

	/**
	 * Color map item by symbol
	 * @param {string} symbol - The symbol identifier
	 * @param {string} color - The fill color
	 */
	const colorMap = ( symbol, color = defaultColor ) => {

		if ( !symbol ) {

			return;

		}

		const mapItem = map?.querySelector( `#${symbol}` );

		if ( mapItem ) {

			mapItem.style.fill = color;

		}

	};

	/**
	 * Initialize map by setting default colors
	 */
	const initMap = () => {

		mapElements.forEach( ( element ) => {

			element.style.fill = defaultColor;

		} );

	};

	/**
	 * Update map colors based on active items
	 */
	const updateMapColors = () => {

		// Reset all map elements to default color
		initMap();

		// Color active items or all when none are active
		const activeItems = block.querySelectorAll( '.b-interactive-map-item--active' );

		const allItems = block.querySelectorAll( '.b-interactive-map-item' );

		if ( activeItems.length === 0 ) {

			allItems.forEach( ( item ) => {

				const itemSymbol = item.dataset.symbol;
				if ( itemSymbol ) {

					colorMap( itemSymbol, activeColor );

				}

			} );

			return;

		}

		activeItems.forEach( ( activeItem ) => {

			const itemSymbol = activeItem.dataset.symbol;
			if ( itemSymbol === 'global' ) {

				allItems.forEach( ( item ) => {

					const innerSymbol = item.dataset.symbol;
					if ( innerSymbol ) {

						colorMap( innerSymbol, activeColor );

					}

				} );

			} else if ( itemSymbol ) {

				colorMap( itemSymbol, activeColor );

			}

		} );

	};

	/**
	 * Toggle item state
	 * @param {HTMLElement} item - The item element
	 */
	const toggleItem = ( item ) => {

		const isActive = item.classList.contains( 'b-interactive-map-item--active' );
		const content = item.querySelector( '.b-interactive-map-item__content' );

		if ( isActive ) {

			item.classList.remove( 'b-interactive-map-item--active' );
			content.style.height = '0px';

		} else {

			// Close all items
			const allItems = block.querySelectorAll( '.b-interactive-map-item' );
			allItems.forEach( ( otherItem ) => {

				otherItem.classList.remove( 'b-interactive-map-item--active' );
				const otherContent = otherItem.querySelector( '.b-interactive-map-item__content' );
				if ( otherContent ) {

					otherContent.style.height = '0px';

				}

			} );

			// Open clicked item
			const textWrapper = item.querySelector( '.b-interactive-map-item__text-wrapper' );
			const height = textWrapper?.scrollHeight ?? 0;

			item.classList.add( 'b-interactive-map-item--active' );
			content.style.height = `${height}px`;

		}

		// Update map colors after state change
		updateMapColors();

	};

	initMap();
	updateMapColors();

	/**
	 * Handle click events using event delegation
	 * @param {Event} e - Click event
	 */
	block.addEventListener( 'click', ( e ) => {

		const item = e.target.closest( '.b-interactive-map-item' );
		if ( item ) {

			toggleItem( item );

		}

	} );

} );